import React from 'react';
import Appoinment from '../../../Pages/Home/Appoinment/Appoinment';
import Banner from '../Banner/Banner';
import Detail from '../Detail/Detail';
import Safety from '../Safety/Safety';

const Service = () => {
    return (
        <>
          <Banner /> 
          <Detail />
          <Safety />
          <Appoinment /> 
        </>
    );
};

export default Service;